<script lang="ts" setup>
interface Props {
  id: string
  checked?: boolean
  disabled?: boolean
  hasError?: boolean
  testid?: string
}

withDefaults(defineProps<Props>(), {
  name: '',
  hasError: false,
  checked: false,
  disabled: false,
  testid: undefined,
})

const emit = defineEmits<{ (e: 'change', val: boolean): void }>()

const handleChange = (event: Event) => {
  emit('change', (event.target as HTMLInputElement).checked)
}

</script>

<template>
  <div class="form-check prevent_unselection">
    <input
      :id="id"
      :checked="checked"
      :disabled="disabled"
      :data-testid="testid"
      type="checkbox"
      @change="handleChange"
      class="form-check-input"
    >
    <label
      :for="id"
      class="form-check-label"
    >
      <slot />
    </label>
  </div>
</template>

<style lang="scss" scoped>
.form-check-input {
  border-color: $gray-900;
}

.form-check-input:checked {
  background-color: $indigo-500;
  border-color: $indigo-500;
}
</style>
